<template>
  <div>
    <h5>Impact Amounts</h5>

    <table v-if="impactAmounts" class="table impact-amounts-table">
      <tbody>
      <tr v-for="impactAmount in impactAmounts"
          :key="impactAmount.id"

          :class="{'inactive-row': !checkedNames.find(c => c.id ==impactAmount.id )}"
      >
        <td width="40px">
          <label class="form-switch">
            <input
                type="checkbox"
                class="donation-impact-amount-checkbox"
                :value="{id: Number(impactAmount.id)}"
                v-model="checkedNames"
            />
          </label>

        </td>
        <td>${{ impactAmount.amount / 100 | formatMoney(2) }}</td>
        <td>

          <span style="cursor: default"
                v-popover.top="{ name: `popover_${impactAmount.id}` }"
          >{{ impactAmount.name }}</span>

          <popover :name="`popover_${impactAmount.id}`"
                   :width="300"
                   event="hover"
                   :delay="300"
                   transition="show-popover"
          >
            <div class="popover-container">
              <div class="card">
                <div class="card-image">
                  <img class="img-responsive"
                       style="width: 100%"
                       :src="impactAmount.image"

                  >
                </div>
                <div class="card-header">
                  <h5>{{ impactAmount.name }}</h5>
                </div>
                <p style="font-weight: normal">{{ impactAmount.description }}</p>
              </div>
            </div>
          </popover>

        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: "ImpactAmounts",

  props: {
    impactAmounts: null,
    value: null
  },
  mounted() {
    this.checkedNames = this.value
  },
  watch: {
    checkedNames(val) {
      this.$emit('input', val);
    },
  },
  data() {
    return {
      checkedNames: []
    }
  }
}
</script>

<style lang="scss">
.inactive-row{
  opacity: .3;
}
.show-popover-enter-active,
.show-popover-leave-active {
  transition: transform 0.3s, opacity 0.3s;
}
.show-popover-enter,
.show-popover-leave-to {
  opacity: 0;
}
.table.impact-amounts-table {
  td:not(:first-of-type) {
    font-weight: normal;
    padding: 15px;
  }
}
</style>